<template>
  <div id="app" v-bind:style="{backgroundColor: background, backgroundImage: 'url(' + background_image + ')' }">
    <div v-if="isShow"  style="position: relative;width: 100%">
      <img style="width: 100%;" :src="pc_top_img"/>

      <img src="./assets/close.png" @click="close"
           style="z-index: 10;position: absolute;top: 0;background-color: black;right: 100px;width: 30px"/>
    </div>
    <div style="position: absolute;z-index: 1;overflow: hidden;width: 100%;" class="top-box">
      <!-- <img src="./assets/top-bg.ae4eab61.png" style="width: 100%;"> -->
      <div class="bg_src"></div>
    </div>

    <div style="position: relative;">
      <router-view class="mainWdith"/>
      <Footer></Footer>
      <div ref=""></div>
      <FixedToolbar/>
    </div>

  </div>
</template>

<script>
import Footer from "./components/footer.vue"
import FixedToolbar from "./components/FixedToolbar.vue"
import {totalapi} from "./api/http";

export default {
  name: 'App',
  components: {
    Footer, FixedToolbar
  },
  data() {
    return {
      background: '',
      background_image: '',
      isShow: true,
      pc_top_img: ''
    }
  },
  async created() {
    await this.setSetting();
  },
  mounted() {

  },
  methods: {
    close() {
      this.isShow = false
    },
    async setSetting() {
      if (sessionStorage.getItem('total') === null) {
        const res1 = await totalapi()
        if (res1.data.code === 200) {
          this.background_image = res1.data.data.mch_info.pc_background
          this.background = res1.data.data.mch_info.pc_background_color
          this.pc_top_img = res1.data.data.mch_info.pc_top_img
          sessionStorage.setItem("total", JSON.stringify(res1.data.data))
          location.reload();
        } else {
          this.$message(res1.data.msg)
        }
      } else {
        var total = JSON.parse(sessionStorage.getItem('total'))
        this.background_image = total.mch_info.pc_background
        this.background = total.mch_info.pc_background_color
        this.pc_top_img = total.mch_info.pc_top_img
      }
    }
  },
}
</script>

<style scoped lang="less">
@import url('~@/assets/style/var.less');

#app {
  background-image: url('~@/assets/center-bg.b32c4363.png');
  background-color: @bg-color;
  background-repeat: round;
  min-width: 100%;
  min-height: 100%;

  .top-box {
    width: @main-width;
    overflow: hidden;

  }


  .mainWdith {
    width: @main-width;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue